export default __webpack_public_path__ + "static/media/banner_graphic.fbac2bc4.svg";